import React from 'react';
import PropTypes from 'prop-types';
import { useSelectorWithDispatch } from '@ers/hooks';
import { Variants } from '@ers/ui/Typo';
import { Typo } from '@ers/ui/';
import { getUnreadThreads } from '@ers/pages/messages/Messages.selectors';
import { fetchThreadsUnreadCounter } from '@ers/pages/messages/Messages.actions';

export const UnreadCounter = ({ counter }) => (
    counter ? <span className="counter"><Typo.Body variant={Variants.WHITE}>{counter}</Typo.Body></span> : null
);
UnreadCounter.propTypes = {
    counter: PropTypes.number
};
UnreadCounter.defaultProps = {
    counter: null
};
const UnreadCounterHooked = () => {
    const counter = useSelectorWithDispatch(
        getUnreadThreads,
        fetchThreadsUnreadCounter,
        (t) => t === null
    );
    return <UnreadCounter counter={counter} />;
};

export default UnreadCounterHooked;


